export const name = "JSON_TYPE";
export const summary = `Gets the JSON type of the outermost JSON value and converts the name of this type to a SQL \`STRING\` value.`;
export const reference = `
## JSON_TYPE

Gets the JSON type of the outermost JSON value and converts the name of this type to a SQL \`STRING\` value.

\`\`\`
JSON_TYPE(json_expr)
\`\`\`

### Description

Gets the JSON type of the outermost JSON value and converts the name of this type to a SQL \`STRING\` value. The names of these JSON types can be returned: \`object\`, \`array\`, \`string\`, \`number\`, \`boolean\`, \`null\`

Arguments:

- \`json_expr\`: JSON. For example:


### Return type

\`STRING\`


### Examples



\`\`\`
SELECT json_val, JSON_TYPE(json_val) AS type
FROM
  UNNEST(
    [
      JSON '"apple"',
      JSON '10',
      JSON '3.14',
      JSON 'null',
      JSON '{"city": "New York", "State": "NY"}',
      JSON '["apple", "banana"]',
      JSON 'false'
    ]
  ) AS json_val;

/*----------------------------------+---------*
 | json_val | type |
 +----------------------------------+---------+
 | "apple" | string |
 | 10 | number |
 | 3.14 | number |
 | null | null |
 | {"State":"NY","city":"New York"} | object |
 | ["apple","banana"] | array |
 | false | boolean |
 *----------------------------------+---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
